import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useLayoutEffect } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Card from "react-bootstrap/Card";
import "../styles/sidemenu.css";
import "../styles/style.css";
import { Header } from "./header";
import { Navcustom } from "./nav";
import { Menutop } from "./menu";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
export function Layout(param) {
    var selectbranchID = param.selectbranchID, setSelectBranchID = param.setSelectBranchID;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var getPageZoom = function() {
        var zoom = window.innerWidth / 1920;
        document.documentElement.style.setProperty("--zoom", zoom);
    };
    // useLayoutEffect(() => {
    //     window.addEventListener('resize', getPageZoom);
    //     getPageZoom();
    //     return () => window.removeEventListener('resize', getPageZoom);
    // }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "apppage",
        id: "apppage",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "main-content app-content",
            style: {
                paddingTop: isMobile ? "70px" : ""
            },
            children: [
                /*#__PURE__*/ _jsx(Navcustom, {
                    setSelectBranchID: setSelectBranchID,
                    selectbranchID: selectbranchID
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "container-fluid",
                    children: [
                        /*#__PURE__*/ _jsx(Menutop, {}),
                        /*#__PURE__*/ _jsx(Outlet, {})
                    ]
                })
            ]
        })
    });
}
